'use strict';

bbw.service.AuthSvc = Class({

    $inject: ['rpcClient', 'bbw.RedirectSvc'],

    _rpcClient: undefined,
    _redirectSvc: undefined,

    construct: function(rpcClient, redirectSvc) {
        this._rpcClient = rpcClient;
        this._redirectSvc = redirectSvc;
    },

    _getIntendedCurrentUrl: function() {
        var url = ('' + window.location) || '/';
        if (url.substr(0, 3) === '/p/') {
            url = url.substr(2);
        }
        return url;
    },

    authByPassword: function(email, password, remember, use_intended_current_url) {
        var args = {
            email: email,
            password: password,
            remember: !!remember
        };
        if (use_intended_current_url) {
            args.url_intended = this._getIntendedCurrentUrl();
        }
        return this._rpcClient.post('signin', args).execute().
            then(function(response) {
                this._redirectSvc.redirect(response.redirect);
            }.bind(this));
    },

    oAuth: function(provider, use_intended_current_url) {
        var url = 'oauth/get-url/' + provider;
        if (use_intended_current_url) {
            url += '?url_intended=' + encodeURIComponent(this._getIntendedCurrentUrl());
        }
        return this._rpcClient.get(url).execute().
            then(function(response) {
                this._redirectSvc.redirect(response.redirect);
            }.bind(this));
    }

});

